import React, { forwardRef } from 'react';
import { List } from 'investira.react.components';

/**
 * Adapta a lista MUI ao ref e ao contêiner de medição exigidos pelo Virtuoso.
 */
const ComparadorFundosVirtuosoList = forwardRef(({ children, ...pProps }, pRef) => (
  <div ref={pRef} {...pProps}>
    <List disablePadding>{children}</List>
  </div>
));

export default ComparadorFundosVirtuosoList;
